import React from "react";

export default function Button({ variant = "primary", children, ...rest }) {
  const styles = {
    primary:
      "inline-flex items-center gap-1 rounded-md bg-gradient-to-r from-purple-500 to-indigo-500 px-5 py-2.5 text-sm font-semibold text-white shadow",
    ghost:
      "inline-flex items-center gap-1 rounded-md px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100",
  };
  return (
    <button className={styles[variant]} {...rest}>
      {children}
    </button>
  );
}
